import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import values from 'lodash/values';
import { loadPromoCodes,deletePromoCode } from '../../shared/redux/entities/actions';


function mapStateToProps(state){
  //TODO: Connect Redux state to ProviderPromoCodeList

  return {
    promoCodes:values(state.entities.promoCodes)
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to ProviderPromoCodeList
  return bindActionCreators({ 
    loadPromoCodes,
    deletePromoCode 
  },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/ProviderPromoCodeList/connect.js